/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilters_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuDrawerAppliedFilterDisplay_user" | "SbRespRefineMenuFilterPrice_user" | "SbRespRefineMenuFilterDimensions_user" | "SbMobileRefineMenuFilterPrice_user" | "SbMobileRefineMenuFilterDimensions_user">;
    readonly " $refType": "SbSharedRefineMenuFilters_user";
};
export type SbSharedRefineMenuFilters_user$data = SbSharedRefineMenuFilters_user;
export type SbSharedRefineMenuFilters_user$key = {
    readonly " $data"?: SbSharedRefineMenuFilters_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawerAppliedFilterDisplay_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_user",
      "args": null
    }
  ]
};
(node as any).hash = '54e637d98caa282d701c4b9acc3329b0';
export default node;
